import React from "react";
import PropTypes from "prop-types";
import Button from "../../shared/button";
import styles from "./styles.css";
import CarImage from "./images/approved-car.png";
import { makePriceLabelRound } from "../../../utils/helpers/make-price-label";

const PreApprovedCarCard = ({maxLoanAmount, handleApplyFilter}) => {
    return (
        <div styleName={"styles.wrapper"}>
            <img src={CarImage} />
            <p styleName={"styles.description"}>You’ve been<br />pre-approved<br />for cars upto <span>{makePriceLabelRound(maxLoanAmount)}</span></p>
            <div styleName={"styles.bottomBorder"}>&nbsp;</div>
            <Button text={`VIEW CARS UNDER ${makePriceLabelRound(maxLoanAmount)}`} onClick={handleApplyFilter}/>
        </div>
    );
};

PreApprovedCarCard.propTypes = {
    maxLoanAmount: PropTypes.number,
    handleApplyFilter: PropTypes.func
};
export default PreApprovedCarCard;
